import { z } from 'zod';

export interface OptionalNumberOptions {
    /** Giá trị nhỏ nhất cho phép (bao gồm). Mặc định 0 -> không cho phép số âm */
    min?: number;
    /** Nếu true, giá trị phải lớn hơn min (không bằng min) */
    exclusiveMin?: boolean;
    /** Giá trị lớn nhất cho phép */
    max?: number;
    /** Chỉ cho phép số nguyên */
    int?: boolean;
}

/**
 * Trường số tùy chọn cho form: chấp nhận number hoặc chuỗi số, chuỗi rỗng/null -> undefined.
 * Báo lỗi bằng tiếng Việt khi không phải số, số âm hoặc vượt giới hạn.
 */
export const optionalNumber = (label: string, options: OptionalNumberOptions = {}) => {
    const { min = 0, exclusiveMin = false, max, int = false } = options;

    return z.preprocess(
        (v) => {
            if (v === null || v === undefined) return undefined;
            if (typeof v === 'string') {
                const trimmed = v.trim();
                if (trimmed === '') return undefined;
                const num = Number(trimmed.replace(/,/g, ''));
                return Number.isNaN(num) ? v : num;
            }
            return v;
        },
        z
            .number({ invalid_type_error: `${label} phải là số` })
            .refine((n) => Number.isFinite(n), { message: `${label} phải là số hợp lệ` })
            .refine((n) => !int || Number.isInteger(n), { message: `${label} phải là số nguyên` })
            .refine((n) => (exclusiveMin ? n > min : n >= min), {
                message: exclusiveMin
                    ? `${label} phải lớn hơn ${min}`
                    : `${label} phải lớn hơn hoặc bằng ${min}`,
            })
            .refine((n) => max === undefined || n <= max, {
                message: `${label} không được vượt quá ${max}`,
            })
            .optional(),
    );
};
